// CMS GTM for button
export const gtmEventTypes = {
  CLICK_BUTTON: 'CMS-BUTTON-001',
}

export const gtmEvents = {
  [gtmEventTypes.CLICK_BUTTON]: ({CMSGroupGTM, buttonName}) => ({
    ...CMSGroupGTM,
    type: gtmEventTypes.CLICK_BUTTON,
    event: 'reactjs.event',
    pageAction: `${CMSGroupGTM.action} - Clicked "${buttonName.toUpperCase()}"`,
  }),
}



// WEBPACK FOOTER //
// ./src/store/gtm-events/button-duck.js